var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6071 3.00195C14.3845 2.99475 15.0048 3.62109 15 4.40746L14.8149 13.3369L14.8148 13.3467C14.8076 14.147 14.1564 14.806 13.3659 14.8134L4.53538 15C3.75859 15.0048 3.13975 14.377 3.14687 13.5901C3.15411 12.7897 3.80526 12.1307 4.59585 12.1233L4.60834 12.1232L9.90918 11.9112L0.58218 2.47007C0.0452994 1.92663 0.0382137 1.01604 0.611226 0.436024C1.18422 -0.143974 2.08376 -0.136799 2.62061 0.406621L11.9473 9.84742L12.158 4.48141L12.1581 4.46867C12.1654 3.66834 12.8165 3.00927 13.6071 3.00195Z",
    fill: "#E44829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowRed);
export default __webpack_public_path__ + "static/media/down-arrow-red.504e1793baeabcd56bd36a09f64ca0b6.svg";
export { ForwardRef as ReactComponent };